import React from 'react';
import './jobCard.scss';
import '../../molecules/share-modal/shareModal';
import SharekIcon from "../../atoms/icons/Share";
import Button from "../../atoms/button/button";

interface VacancyProps {
    title?: string;
    date?: string;
    company?: string;
    city?: string;
    referenceNumber?: number;
    url?: string;
    salary?: number;
    setIsOpenModalShare? : any;
    setModalReferenceNumber? : any;
}

const JobCard = (props: VacancyProps) => {
    const { title, date, company, city, referenceNumber, setIsOpenModalShare, salary, setModalReferenceNumber } = props;
    const optionCol = { style: 'currency', currency: 'COP' };
    const formattedSalary = new Intl.NumberFormat('es-CO', optionCol);

    return (
      <>
         <div className="m-job-card">
            <div className="m-job-card__header">
               <div className='m-job-card__header__descripcion'>
                  <h3>{title?.split(" ").slice(0, -1).join(" ")}</h3>
                  <div className='m-job-card__header__descripcion__description'>
                     <i className="icon-clock1"></i><p>Publicado {date}</p>
                  </div>
               </div>
               {
                  setIsOpenModalShare && 
                     <div className='m-job-card__header-descripcion-icons'>
                        <img src="https://images.ctfassets.net/203frbsx1z3n/1VfklnvBUHkLHMm6Yatw0v/ec6ea0a16ec2439512d1f5a7b62b2371/Icon_guardar.png"/>
                        <button
                           onClick={() => {
                              setIsOpenModalShare(true);
                              setModalReferenceNumber(referenceNumber);
                           }}
                           title="Compartir"
                           className={`m-job-card__share-button`}
                        >
                           <SharekIcon />
                        </button>
                     </div>
               }
               
            </div>
            <div className="m-job-card__content">
               <div className='m-job-card__content__icon'>
                  <figure className='m-job-card__content__icon__main'>
                     <img src="https://images.ctfassets.net/203frbsx1z3n/7woRhVWnBy4yD8rAEscUC1/ad8341c8596afcc93d3329ea0135ed3e/Trazado_76968.png"/>
                  </figure>
                  <p className='m-job-card__content__icon__text'>
                     <p className='m-job-card__content__icon__text__int'>{company}</p>
                  </p>
               </div>

               <div className='m-job-card__content__icon'>
                  <figure>
                    <img src="https://images.ctfassets.net/203frbsx1z3n/4zls6gPn6LAaRy5oiFyhdj/5ebbd58ffaa051d78458ca2f32cad441/Trazado_76974.png"/>
                  </figure>
                  <p className='m-job-card__content__icon__text'>
                     <p className='m-job-card__content__icon__text__int'>
                        {!salary || salary <= 1
                        ? "Confidencial"
                        : formattedSalary.format(salary)}
                     </p>
                  </p>
               </div>
               <div className='m-job-card__content__icon'>
                  <figure>
                     <img src="https://images.ctfassets.net/203frbsx1z3n/Kp8Ng5SlneaTvDOzdArLi/201c91acb69c03ca60eec0a45133e6d0/Clip_path_group.png"/>
                  </figure>
                  <p className='m-job-card__content__icon__text'>
                     <p className='m-job-card__content__icon__text__int'>
                        {city}
                     </p>
                  </p>
               </div>
            </div>
            <div className='separate'>
                <div className='separate__separetor'></div>
            </div>
            <div className="footer">
               <Button
                  classname={`vacancy-link`}
                  type="link"
                  text="Ver detalle de vacante"
                  href={`/servicio-de-empleo/personas/vacantes-en-antioquia/vacante/?id=${referenceNumber}`}
                  isDisabled={false}
               />
            </div>
        </div>
      </>
    );
    
};

export default JobCard;